/** The Claude model /api/generate calls. */
export const MODEL = 'claude-opus-4-8';

/** Output cap per generation; a stream that reaches it ends with stop_reason `max_tokens`. */
export const MAX_TOKENS = 8000;
